import reducerConstant from 'common/reducerConstants';

const initialState = {
  projects: [],
  activeProject: {},
  activeProjectsList: [],
  activeProjectsListTs: null,
  archivedProjectsList: [],
  milestones: {},
  milestoneTs: null,
  errorMessage: null,
};

const ProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case reducerConstant.getProjectSuccess:
      return {
        ...state,
        activeProjectsList: action.payload.response,
        activeProjectsListTs: Date.now(),
        errorMessage: null,
      };
    case reducerConstant.getProjectFailed:
      return {
        ...state,
        errorMessage: action.payload.message,
        activeProjectsListTs: Date.now(),
      };
    case reducerConstant.getProjectByIdSuccess:
      return {
        ...state,
        activeProject: action.payload.response,
      };
    case reducerConstant.getProjectMilestoneSuccess:
      return {
        ...state,
        milestones: action.payload.response,
        milestoneTs: Date.now(),
      };
    case reducerConstant.getProjectMilestoneFailed:
      return {
        ...state,
        milestoneTs: Date.now(),
      };
    case reducerConstant.resetProjectViewData:
      return {
        ...state,
        activeProject: {},
        milsestones: {},
        errorMessage: null,
        activeProjectsListTs: null,
        milestoneTs: null,
      };
    default:
      return state;
  }
};

export default ProjectReducer;
